import { Link } from '@reach/router';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FooterType,
  NavigationFooterData,
  selectFooter,
  UpdateProfileFooterData,
} from 'reducers/footer';
import LinkedinIcon from '../../../assets/apply.clevry/Icon_Social_01.png';
import LinkedinIconYellow from '../../../assets/apply.clevry/Icon_Social_01_Yellow.png';
import LinkedinIconWhite from '../../../assets/apply.clevry/Icon_Social_01_White.png';
import LinkedinIconBlack from '../../../assets/apply.clevry/Icon_Social_01_Black.png';
import TwitterIcon from '../../../assets/apply.clevry/Icon_Social_02.png';
import TwitterIconYellow from '../../../assets/apply.clevry/Icon_Social_02_Yellow.png';
import TwitterIconWhite from '../../../assets/apply.clevry/Icon_Social_02_White.png';
import TwitterIconBlack from '../../../assets/apply.clevry/Icon_Social_02_Black.png';
import FacebookIcon from '../../../assets/apply.clevry/Icon_Social_04.png';
import FacebookIconYellow from '../../../assets/apply.clevry/Icon_Social_04_Yellow.png';
import FacebookIconWhite from '../../../assets/apply.clevry/Icon_Social_04_White.png';
import FacebookIconBlack from '../../../assets/apply.clevry/Icon_Social_04_Black.png';
import InstagramIcon from '../../../assets/apply.clevry/Icon_Social_05.png';
import InstagramIconYellow from '../../../assets/apply.clevry/Icon_Social_05_Yellow.png';
import InstagramIconWhite from '../../../assets/apply.clevry/Icon_Social_05_White.png';
import InstagramIconBlack from '../../../assets/apply.clevry/Icon_Social_05_Black.png';
import { NavigationFooter } from './NavigationFooter';
import { UpdateProfileFooter } from './UpdateProfileFooter';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';
import { selectAccessibilityData } from 'reducers/accessibility';
import { selectAccessibilityStatement, selectAccessibilityStatementProjectId } from 'reducers/landingPage';
import { selectPrivacyPolicy } from 'reducers/landingPage';
import { paths } from 'appConstants';
import { selectCandFBDashReportShowing } from 'reducers/candidateFeedbackDashboard';
import { SettingsApi } from 'components/pages/settings/settingsApi';

import englishFlag from 'assets/lang_flags/en-GB.png';
import swedishFlag from 'assets/lang_flags/sv-SE.png';
import finnishFlag from 'assets/lang_flags/fi-FI.png';
import LanguageSearchDropdown from 'components/languagesearchdropdown/LanguageSearchDropdown';
import Select from 'react-select';

// const ONE_YEAR_IN_HOURS = 24 * 365;

type LanguageListReponseDetails = {
  name: string;
  cultureInfo: string;
  imagePath: string;
  imageExtension: string;
  imageUrl: any;
}[];

export type supportedLanguagesData = {
  value: string;
  label: string;
  image: any;
};

export type allSupportedLanguagesData = supportedLanguagesData[];

export const FooterSocials: React.FC = () => {
  const { t } = useTranslation('Footer', { i18n });
  const accessibilityData = useSelector(selectAccessibilityData);  

  const socialIconToShow = (accessibility_str: any, icons_list: any) => {
    if(accessibility_str === "SiteAccessibilityYellow"){
      return icons_list[1];
    } else if (accessibility_str === "SiteAccessibilityWhite") {
      return icons_list[2];
    } else if (accessibility_str === "SiteAccessibilityBlack") {
      return icons_list[3];
    } else {
      return icons_list[0];
    }
  };

  return (
    <div className="Socials">
      <a
        href="https://www.linkedin.com/company/clevry/"
        className="Social"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={socialIconToShow(accessibilityData.siteAccessibilityColour, [LinkedinIcon, LinkedinIconYellow, LinkedinIconWhite, LinkedinIconBlack])} alt={t('SSCandidate_Footer_Alt_LinkedIn_Icon')} />
      </a>
      <a
        href="https://twitter.com/ClevryGroup"
        className="Social"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={socialIconToShow(accessibilityData.siteAccessibilityColour, [TwitterIcon, TwitterIconYellow, TwitterIconWhite, TwitterIconBlack])} alt={t('SSCandidate_Footer_Alt_Twitter_Icon')} />
      </a>
      <a
        href="https://www.instagram.com/clevry.group/"
        className="Social"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={socialIconToShow(accessibilityData.siteAccessibilityColour, [InstagramIcon, InstagramIconYellow, InstagramIconWhite, InstagramIconBlack])}
          alt={t('SSCandidate_Footer_Alt_Instagram_Icon')}
        />
      </a>
      <a
        href="https://www.facebook.com/clevryCOM"
        className="Social"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={socialIconToShow(accessibilityData.siteAccessibilityColour, [FacebookIcon, FacebookIconYellow, FacebookIconWhite, FacebookIconBlack])} alt={t('SSCandidate_Footer_Alt_Facebook_Icon')} />
      </a>
    </div>
  );
};

export const FooterCopyright: React.FC = () => {
  const { t } = useTranslation('Footer', { i18n });

  return (
    <div className="FooterCopyright">
      <p className="Copyright">
        <span>
          {t('SSCandidate_Footer_Copyright', {
            val1: new Date().getFullYear(),
          })}
        </span>
      </p>
    </div>
  );
};

export const FooterCopyrightRight: React.FC = () => (
  <div className="FooterCopyrightRight">
    <p className="Copyright">
      <span>
        Copyright &#169;{new Date().getFullYear()} Clevry. All rights reserved.
      </span>
    </p>
  </div>
);

export const FooterLegalLinks: React.FC = () => {
  const { t } = useTranslation('Footer', { i18n });
  
  const accessibilityStatement = useSelector(selectAccessibilityStatement); 
  const privacyPolicy = useSelector(selectPrivacyPolicy);   
  
  const selectedAccessibilityStatement = accessibilityStatement ?
    accessibilityStatement :
    null;  

  return (
    <>
      <a
        className="FooterLink"
        href="/terms-and-conditions"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('SSCandidate_Footer_Terms_And_Conditions')}
      </a>

      <a
        className="FooterLink"
        href={privacyPolicy ? paths.privacyPolicy.url : 'https://www.clevry.com/en/privacy-policy/'}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('SSCandidate_Footer_Privacy_Policy')}
      </a>

      <a
        className="FooterLink"
        href="https://www.clevry.com/en/cookie-policy/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('SSCandidate_Footer_Cookies_Policy')}
      </a>

      {selectedAccessibilityStatement && 
        <a
          className="FooterLink"
          href="/accessibility-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('SSCandidate_Footer_Accessibility_Statement')}
        </a>
      }     
    </>
  );
};

export const LoggedInFooterLegalLinks: React.FC = () => {
  const { t } = useTranslation('Footer', { i18n });
  
  const accessibilityStatement = useSelector(selectAccessibilityStatement);  
  const accessibilityStatementProjectId = useSelector(selectAccessibilityStatementProjectId);  
  const privacyPolicy = useSelector(selectPrivacyPolicy);  

  const selectedAccessibilityStatement = accessibilityStatement ?
    accessibilityStatement :
    null; 
    
  const currentWebskin = window.sessionStorage.getItem('webskin')
    ? window.sessionStorage.getItem('webskin')
    : 'defaultTheme';    

  return (
    <>
      {currentWebskin === "SSCL-MoJ" &&
        <a
          className="FooterLink"
          href={privacyPolicy ? paths.privacyPolicy.url : 'https://www.clevry.com/en/privacy-policy/'}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('SSCandidate_Footer_Privacy_Policy')}
        </a>      
      }
      {selectedAccessibilityStatement && 
        <a
          className="FooterLink"
          href={accessibilityStatementProjectId ? ("/accessibility-statement/" + accessibilityStatementProjectId) : "/accessibility-statement"}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('SSCandidate_Footer_Accessibility_Statement')}
        </a>
      }     
    </>
  );
};

interface FooterProps {
  isThemed: boolean;
}

const Footer: React.FC<FooterProps> = ({ isThemed }) => {
  const { data, footerType } = useSelector(selectFooter);

  const currentWebskin = window.sessionStorage.getItem('webskin')
    ? window.sessionStorage.getItem('webskin')
    : 'defaultTheme';  
    
  const candidateFeedbackDashboardShowing = useSelector(
    selectCandFBDashReportShowing
  );

  const dispatch = useDispatch();

  const emptyInitalLanguageValue = {
    value: '',
    label: '',
    image: null,
  };

  const [languageValue, setLanguageValue] = useState<any>(
    emptyInitalLanguageValue
  );
  const [languagesList, setLanguagesList] = useState<allSupportedLanguagesData>(
    []
  );

  const { t } = useTranslation('Footer', { i18n });

  const backupLanguageList: supportedLanguagesData[] = [
    {
      value: 'en-GB',
      label: t('SSCandidate_Footer_English'),
      image: englishFlag,
    },
    {
      value: 'sv-SE',
      label: t('SSCandidate_Footer_Swedish'),
      image: swedishFlag,
    },
    {
      value: 'fi-FI',
      label: t('SSCandidate_Footer_Finnish'),
      image: finnishFlag,
    },
  ];

  const [langDropdownToggle, setLangDropdownToggle] = useState<boolean>(false);

  function toggleLanguageDropdown() {
    setLangDropdownToggle(!langDropdownToggle);
  }

  const parseLanguageList = (
    data: LanguageListReponseDetails
  ): allSupportedLanguagesData => {
    return data.map((item) => {
      return {
        value: item.cultureInfo,
        label: item.name,
        image: item.imageUrl,
      };
    });
  };

  const handleLanguageDropdown = (e: any) => {
    setLanguageValue(e);
    (async () => {
      const result = await SettingsApi.setLanguage(e.value);

      if (result.data === '1') {
        // // Expire in 1 year:
        // const cookieExpireTime = new Date();
        // cookieExpireTime.setHours(
        //   cookieExpireTime.getHours() + ONE_YEAR_IN_HOURS
        // );

        // // staging:

        // if (cookieDomain !== '') {
        //   setCookie('cultureInfo', e.value, {
        //     domain: cookieDomain,
        //     expires: cookieExpireTime,
        //   });
        // }

        // localhost:
        // setCookie('cultureInfo', e.value, { expires: cookieExpireTime });

        i18n.changeLanguage(e.value);

        // dispatch(setDashboardInfo({ ...dashboardInfo, cultureCode: e.value }));
      }
      if (result.error && result.error.length > 0) {
        // setErrorMessage(result.error[0]);
      }
    })();

    toggleLanguageDropdown();
  };

  // Fetch the Languages List:
  useEffect(() => {
    (async () => {
      try {
        const data = await SettingsApi.getLanguageList();

        if (data.response && data.response.length > 0) {
          const parsedAPIData = parseLanguageList(data.response);

          // return parsedAPIData;
          setLanguagesList(parsedAPIData);

          // Find English in the list and set it as the default selected value
          const defaultLanguage = parsedAPIData.find(
            (lang) => lang.value === 'en-GB'
          );
          setLanguageValue(defaultLanguage);
        } else {
          console.log('Failed To Get Language List');

          // setLanguagesList([
          //   {
          //     value: 'en-GB',
          //     label: 'English',
          //     image: englishFlag,
          //   },
          //   {
          //     value: 'sv-SE',
          //     label: 'Swedish',
          //     image: swedishFlag,
          //   },
          //   {
          //     value: 'fi-FI',
          //     label: 'Finnish',
          //     image: finnishFlag,
          //   },
          // ]);

          setLanguagesList(backupLanguageList);

          setLanguageValue({
            value: 'en-GB',
            label: 'English',
            image: englishFlag,
          });
        }
      } catch (error) {
        console.error('Error fetching languages:', error);

        setLanguagesList([
          { value: 'en-GB', label: 'English', image: englishFlag },
        ]);
      }

      // // LanguageValue:
      // try {
      //   if (cookies['cultureInfo']) {
      //     const cultureInfoCookie = cookies['cultureInfo'];

      //     const [languageLabel, languageImage] =
      //       handleLabelAndImage(cultureInfoCookie);

      //     if (languageLabel !== '') {
      //       setLanguageValue({
      //         value: cultureInfoCookie,
      //         label: languageLabel,
      //         image: languageImage,
      //       });
      //     } else {
      //       // NOTE: I don't think we want "English" translated here
      //       setLanguageValue({
      //         value: 'en-GB',
      //         label: 'English',
      //         image: englishFlag,
      //       });
      //     }

      //     // i18n.changeLanguage(cultureInfoCookie);
      //   } else {
      //     // NOTE: I don't think we want "English" translated here
      //     setLanguageValue({
      //       value: 'en-GB',
      //       label: 'English',
      //       image: englishFlag,
      //     });

      //     // i18n.changeLanguage('en-GB');
      //   }
      // } catch {
      //   // NOTE: I don't think we want "English" translated here
      //   setLanguageValue({
      //     value: 'en-GB',
      //     label: 'English',
      //     image: englishFlag,
      //   });

      //   // i18n.changeLanguage('en-GB');
      // }

      setLanguageValue({
        value: 'en-GB',
        label: 'English',
        image: englishFlag,
      });
    })();
  }, []);

  // Handle language change

  const handleLanguageChange = (
    selectedOption: supportedLanguagesData | null
  ) => {
    if (selectedOption) {
      i18n.changeLanguage(selectedOption.value);
      setLanguageValue(selectedOption);
    }
  };  

  // Don't include NavigationFooter in Footer div as it doesn't obey the same
  // syling rules.
  if (footerType === FooterType.NAVIGATION_FOOTER) {
    return (
      <div className={`NavigationFooterContainer  ${isThemed ? 'Themed' : ''}`}>
        <NavigationFooter {...(data as NavigationFooterData)} />
      </div>
    );
  }
  if (footerType === FooterType.NONE) {
    return null;
  }

  // Extra styles to govern the behaviour of the language dropdown menu
  const customStyles = {
    input: (provided: any) => ({
      ...provided,
      margin: "0px",
      padding: "0px",
    }),
    menu: (provided: any) => ({
      ...provided,
      maxHeight: "150px", // Setting a max height
      overflowY: "auto", // Enable scrolling
      backgroundColor: '#f5f5f5'
    })
  }  

  return (
    <footer className={`Footer ${isThemed ? 'Themed' : ''} WidthContent`}>
      {footerType === FooterType.LOGGED_IN ? (
        <div className="FooterLinks LoggedInFooter">
          <div className="LeftContainer">
            <FooterSocials />
            <LoggedInFooterLegalLinks />
          </div>
          {candidateFeedbackDashboardShowing && (
            <div>
              {/* <LanguageSearchDropdown
                isOpen={langDropdownToggle}
                options={languagesList}
                value={languageValue}
                onChange={handleLanguageDropdown}
                toggleDropdown={() => {
                  toggleLanguageDropdown();
                }}
              /> */}
              {/* Alternative language selector */}
              <div className="">
                <label>
                  <Select
                    options={languagesList}
                    value={languageValue}
                    formatOptionLabel={(e) => (
                      <div>
                        <img
                          src={e.image}
                          alt="Language flag"
                          className="FlagIcon"
                        />
                        {e.label}
                      </div>
                    )}
                    getOptionValue={(e) => e.value}
                    placeholder="" // Or should this have a default?
                    onChange={handleLanguageChange}
                    menuPlacement="top" // To open the dropdown upwards
                    className="FooterLanguageDropdown"
                    styles={customStyles}
                  />
                </label>
              </div>
            </div>
          )}          
          <FooterCopyright />
        </div>
      ) : footerType === FooterType.COPYRIGHT_ONLY ? (
        <FooterCopyright />
      ) : footerType === FooterType.COPYRIGHT_ONLY_RIGHT ? (
        <FooterCopyrightRight />
      ) : footerType === FooterType.PUBLIC_ALL_ELEMENTS ? (
        <>
          <div className="FooterLinks">
            <FooterSocials />
            <FooterLegalLinks />
          </div>
          {/* {candidateFeedbackDashboardShowing && (
            // <p>Language dropdown goes here </p>
            <div style={{position: 'relative', maxWidth: 300}}>
              <LanguageSearchDropdown
                isOpen={langDropdownToggle}
                options={languagesList}
                value={languageValue}
                onChange={handleLanguageDropdown}
                toggleDropdown={() => {
                  toggleLanguageDropdown();
                }}
              />
            </div>
          )} */}
          <div
            className="FooterRightContainer"
            style={{ position: 'relative' }}
          >
            {candidateFeedbackDashboardShowing && (
              <div
                style={
                  {
                    // position: 'fixed', right: 250, bottom: 10
                  }
                }
              >
                {/* <LanguageSearchDropdown
                  isOpen={langDropdownToggle}
                  options={languagesList}
                  value={languageValue}
                  onChange={handleLanguageDropdown}
                  toggleDropdown={() => {
                    toggleLanguageDropdown();
                  }}
                /> */}
                {/* Alternative language selector */}
                <div className="LanguageSelector">
                  <label>
                    <Select
                      options={languagesList}
                      value={languageValue}
                      formatOptionLabel={(e) => (
                        <div className="CustomOption">
                          <div className="LangFlagContainer">
                            <img
                              src={e.image}
                              alt="Language flag"
                              className="LangFlag"
                            />
                          </div>
                          <div className="LangText">{e.label}</div>
                        </div>
                      )}
                      getOptionValue={(e) => e.value}
                      placeholder="" // Or should this have a default?
                      onChange={handleLanguageChange}
                      menuPlacement="top" // To open the dropdown upwards
                      className="FooterLanguageDropdown"
                      styles={customStyles}
                    />
                  </label>
                </div>
              </div>
            )}{' '}
            <div className="FooterRight">
              <FooterCopyright />
            </div>
          </div>                    
        </>
      ) : footerType === FooterType.UPDATE_PROFILE ? (
        <UpdateProfileFooter {...(data as UpdateProfileFooterData)} />
      ) : null}
    </footer>
  );
};

export { Footer };
